import React from "react";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PresenterIcon from "../../icons/PresenterIcon";
import styles from "./VideoPresenter.module.css";
import useResponsive from "../../../../common/useResponsive";

interface VideoPresenterProps {
    presenter: string;
}

export default function VideoPresenter({presenter}: VideoPresenterProps) {
    const { isMobile } = useResponsive();
    return (
        <div className={styles.presenter}>
            <div className={styles.presenterIcon}>
                <PresenterIcon color="grey-61" size={isMobile ? 10 : 14} />
            </div>

            <PuiTypography color="gray-61" size={isMobile ? 12 : 16}>{presenter}</PuiTypography>
        </div>
    );
}
